import React, { useEffect, useState } from 'react'
import moment from 'moment'
import dayjs from 'dayjs'
import { DatePicker, TimePicker } from 'antd'
const { RangePicker } = DatePicker


const App = (props) => {
  let rangevalue = null
  // console.log(props);
  const { onChange = () => { }, value = "", dateFormat = 'YYYY-MM-DD', picker = "", disabledDate = '' } = props
  if (["rangepicker"].includes(picker) && value) {
    rangevalue = value.split(',')
  }
  const [date, setDate] = useState(value)
  const disabledDatea = (current) => {
    return current && current >= dayjs(new Date())
  }

  useEffect(() => {
    // console.log(date);
    // onChange(date)
    // eslint-disable-next-line
  }, [date])

  const customWeekStartEndFormat = () => {
    console.log(value)
    return `${moment(value).startOf('week').format(dateFormat)} ~ ${moment(value)
      .endOf('week')
      .format(dateFormat)}`
  }
  return (
    <>
      {picker === "" && <DatePicker defaultValue={value && moment(value, dateFormat)} format={dateFormat} onChange={(a, b) => { onChange(b) }} />}
      {["year", "month"].includes(picker) && <DatePicker disabledDate={disabledDate === 'now' ? disabledDatea : false} defaultValue={value && moment(value, dateFormat)} format={dateFormat} picker={picker} onChange={(a, b) => { onChange(b) }} />}
      {["week"].includes(picker) && <DatePicker defaultValue={value && moment(value)} picker={picker} onChange={(a, b) => { onChange(b) }} />}
      {["rangepicker"].includes(picker) && <RangePicker disabledDate={disabledDate === 'now' ? disabledDatea : false}
        defaultValue={rangevalue !== null && [moment(rangevalue[0], dateFormat), moment(rangevalue[1], dateFormat)]}
        format={dateFormat} onChange={(a, b) => { onChange(b) }}
      />}

      {picker === "time" && <TimePicker defaultValue={value && moment(value, dateFormat)} format={dateFormat} onChange={(a, b) => { onChange(b) }} />}




    </>
  )
}
export default App